import React from "react";
import "./logo-style.css";

const CSSLogo = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      role="img"
      width="36px"
      height="36px"
      preserveAspectRatio="xMidYMid meet"
      viewBox="0 0 512 512"
      color="#33A9DC"
      className="css-logo"
    >
      <path
        fill="currentColor"
        d="m480 32l-64 368l-223.3 80L0 400l19.6-94.8h82l-8 40.6L210 390.2l134.1-44.4l18.8-97.1H29.5l16-82h333.7l10.5-52.7H56.3l16.3-82H480z"
      />
    </svg>
  );
};

export default CSSLogo;
